import {DateFormat} from "../../assets/utils";
import React from "react";

const PublicationDate = ({date}) => {
    return (
        <li className="list-none text-lg font-semibold text-gray-700 bg-gray-100 rounded-md shadow-md p-2">Publication date: <DateFormat date={date}/></li>
    )
}

export default PublicationDate